import { createContext, useContext } from 'react'
import { SearchResultsSortKey } from './SearchResultsSortKey'
import { SearchParamsResult } from './useSearchParams'

export type SearchParamsContextProps = {
  searchParams: SearchParamsResult
}

export const SearchParamsContext = createContext<SearchParamsContextProps>({
  searchParams: {
    tags: [],
    models: [],
    brands: [],
    machineType: undefined,
    machineSubType: undefined,
    baleChamber: undefined,
    headerType: undefined,
    amount: 0,
    features: [],
    rangeFilters: {},
    locations: [],
    sort: SearchResultsSortKey.RelevanceAsc,
    isOnMachineCategoryPage: false,
  },
})

export const useSearchParamsContext = () => useContext(SearchParamsContext)
